import { render, staticRenderFns } from "./send_to_me.vue?vue&type=template&id=66e7cbd8&scoped=true&"
import script from "./send_to_me.vue?vue&type=script&lang=js&"
export * from "./send_to_me.vue?vue&type=script&lang=js&"
import style0 from "./send_to_me.vue?vue&type=style&index=0&id=66e7cbd8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e7cbd8",
  null
  
)

export default component.exports